import { getContext } from '@/context';
import { getAppStore } from '@/store';
import { clearAllGenerations } from '@/utils/storage/generationStorage';

export const logout = async (): Promise<void> => {
  try {
    await clearAllGenerations();
    getAppStore().resetAll(); // Clear in-memory generation state
    const result = await getContext().handlers.publishEvent({
      event: 'logout',
    });
    if (result) {
      await getContext().handlers.refreshToken();
    }
  } catch {
    console.error('[authActions] Error logging out');
  }
};

export const deleteAccount = async (): Promise<void> => {
  try {
    await getContext().handlers.publishEvent({ event: 'delete_account' });
  } catch {
    console.error('[authActions] Error deleting account');
  }
};
